import contractor_history_mutations from './contractor_history/mutation_types.js';
import modal_connect_with_mutations from './modal_connect_with/mutation_types.js';
import modal_generate_balance_mutations from './modal_generate_balance/mutation_types.js';
import price_list_mutations from './price_list/mutation_types.js';
import payments_mutations from './payments/mutation_types.js';

export default Object.assign(
    {
        SET_USER_INFO: 'setUserInfo',
        SET_LANG : 'setLang',
        ADD_TRANSLATIONS: 'addTranslations',
        ADD_SELECT2_CONTRACTORS: 'addSelect2Contractors',
        ADD_SELECT2_ID_NUMBERS: 'addSelect2IdNumbers',
        ADD_SELECT2_DOCUMENTS_CURRENCIES: 'addSelect2DocumentsCurrencies',
        SET_SEVER_INO: 'setServerInfo',
        SET_COUNTRIES_TRANSLATIONS: 'setCountriesTranslations'
    },
    contractor_history_mutations,
    modal_connect_with_mutations,
    modal_generate_balance_mutations,
    payments_mutations,
    modal_generate_balance_mutations,
    price_list_mutations,
);